import {
  BankPaymentsDraftPage,
  BankPaymentsPage,
  BillingAccountsPage,
  ClaimsPage,
  CouponsPage,
  DealsDocumentsPage,
  DealsPage,
  EmailMessagesPage,
  EnquiriesPage,
  EnquiriesSfCasesPage,
  FrameworksPage,
  HsCodesPage,
  IncomingInvoicesPage,
  IntacctEventsPage,
  JobOffersListPage,
  JobsPage,
  LogisticInvoicesPage,
  MessagesPage,
  MessageSubscriptionsPage,
  OrganizationBalancesPage,
  OrganizationsPage,
  OutcomingInvoicesPage,
  PaymentsPage,
  PayoutsPage,
  PersonsPage,
  ProductionScheduleItemsPage,
  ProviderOrdersPage,
  ProvidersPage,
  QualityControlsPage,
  RefundsPage,
  RfqOffersPage,
  RfqsPage,
  ShippingAddressesPage,
  ShippingsListPage,
  StoragesPage,
  TasksPage,
  TeamspacesPage,
  UsersPage,
} from 'pages';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { routes } from 'routes';

export const GeneralWorkspacesController = () => (
  <Switch>
    <Route path={routes.workspacesGeneralIncomingInvoicesPath()} component={IncomingInvoicesPage} exact />
    <Route path={routes.workspacesGeneralOutcomingInvoicesPath()} component={OutcomingInvoicesPage} exact />
    <Route path={routes.workspacesGeneralLogisticInvoicesPath()} component={LogisticInvoicesPage} exact />

    <Route
      path={routes.workspacesGeneralBankPaymentsPath()}
      render={(props) => <BankPaymentsPage key={props.location.key} />}
      exact
    />

    <Route
      path={routes.workspacesGeneralBankPaymentsDraftPath()}
      render={(props) => <BankPaymentsDraftPage key={props.location.key} />}
      exact
    />

    <Route path={routes.workspacesGeneralPartnersPath()} component={ProvidersPage} exact />
    <Route path={routes.workspacesGeneralQualityControlsPath()} component={QualityControlsPage} exact />
    <Route path={routes.workspacesGeneralShippingsPath()} component={ShippingsListPage} exact />
    <Route path={routes.workspacesGeneralStoragesPath()} component={StoragesPage} exact />
    <Route path={routes.workspacesGeneralBillingAccountsPath()} component={BillingAccountsPage} exact />
    <Route path={routes.workspacesGeneralShippingAddressesPath()} component={ShippingAddressesPage} exact />
    <Route path={routes.workspacesGeneralPaymentsPath()} component={PaymentsPage} exact />
    <Route path={routes.workspacesGeneralRefundsPath()} component={RefundsPage} exact />
    <Route path={routes.workspacesGeneralOrganizationBalancesPath()} component={OrganizationBalancesPage} exact />
    <Route path={routes.workspacesGeneralEnquiriesSfCasesPath()} component={EnquiriesSfCasesPage} exact />
    <Route path={routes.workspacesGeneralOrganizationsPath()} component={OrganizationsPage} exact />
    <Route path={routes.workspacesGeneralTeamspacesPath()} component={TeamspacesPage} exact />
    <Route path={routes.workspacesGeneralDealsPath()} component={DealsPage} exact />
    <Route path={routes.workspacesGeneralFrameworksPath()} component={FrameworksPage} exact />
    <Route path={routes.workspacesGeneralPersonsPath()} component={PersonsPage} exact />
    <Route path={routes.workspacesGeneralEnquiriesPath()} component={EnquiriesPage} exact />
    <Route path={routes.workspacesGeneralRfqsPath()} component={RfqsPage} exact />
    <Route path={routes.workspacesGeneralRfqOffersPath()} component={RfqOffersPage} exact />
    <Route path={routes.workspacesGeneralJobsPath()} component={JobsPage} exact />
    <Route path={routes.workspacesGeneralJobOffersPath()} component={JobOffersListPage} />
    <Route path={routes.workspacesGeneralClaimsPath()} component={ClaimsPage} />
    <Route path={routes.workspacesGeneralPayoutsPath()} component={PayoutsPage} exact />
    <Route path={routes.workspacesGeneralProviderOrdersPath()} component={ProviderOrdersPage} exact />
    <Route path={routes.workspacesGeneralProductionSchedulesPath()} component={ProductionScheduleItemsPage} exact />
    <Route path={routes.workspacesGeneralUsersPath()} component={UsersPage} exact />
    <Route path={routes.workspacesGeneralMessagesPath()} component={MessagesPage} exact />
    <Route path={routes.workspacesGeneralEmailMessagesPath()} component={EmailMessagesPage} exact />
    <Route path={routes.workspacesGeneralTasksPath()} component={TasksPage} exact />
    <Route path={routes.workspacesGeneralMessageSubscriptionsPath()} component={MessageSubscriptionsPage} exact />
    <Route path={routes.workspacesGeneralHsCodesPath()} component={HsCodesPage} exact />
    <Route path={routes.workspacesGeneralIntacctEventsPath()} component={IntacctEventsPage} exact />
    <Route path={routes.workspacesGeneralDealsDocumentsPath()} component={DealsDocumentsPage} exact />
    <Route path={routes.promotionsPath()} component={CouponsPage} exact />
  </Switch>
);
